<template>
  <div class="body" align="center">
    <div style="padding-top:64px">
      <el-row>
        <div style="
          font-family: 'Roboto Serif', serif;
          font-weight: 500;
          font-size: 30px;
          line-height: 35px;">
          Don't just take our word for it. Listen to our users!</div>
      </el-row>
    </div>
    <div style="padding-top:28px">
      <img src="@/assets/plugin_img.jpg" style="border-radius: 50px 50px 50px 50px;">
    </div>
    <div style="padding:20px 176px 93px 176px;">
      <carousel :per-page="1" :navigate-to="someLocalProperty" >
        <slide>
          <div style="padding:33px 31px 16px 31px;background-color: #FFFFFF;border-radius: 15px;">
            <p>"Using the ZHR has enabled me to streamline patient information. I stay up to date on our patients' plans. It is easy to transfer our patient data and start using it immediately. The patient portal is easy to use, allowing patients to schedule appointments and pay bills. Overall, we have been pleased with dependability, ease of use, affordability, and support staff."</p>
            <span style="padding:0 48px 36px 888px;">-KARI RAYL</span>
          </div>
        </slide>
      </carousel>
      <!-- <el-carousel  trigger="click" width="1088px" height="166px" style="border-radius: 15px;"
        indicator-position="outside">
        <el-carousel-item v-for="item in 1" :key="item">
          <div style="padding:38px 31px 16px 31px;">
            "Using the ZHR has enabled me to streamline patient information. I stay up to date on our patients' plans. It is easy to transfer our patient data and start using it immediately. The patient portal is easy to use, allowing patients to schedule appointments and pay bills. Overall, we have been pleased with dependability, ease of use, affordability, and support staff."
          </div>
          <div style="padding:0 48px 36px 948px;">-KARI RAYL</div>
        </el-carousel-item>
      </el-carousel> -->
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
  components: {
    Carousel,
    Slide
  }
}
</script>

<style scoped>
.body{
  background-color:#DAE3BB;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #FFFFFF;
}
.el-carousel__item:nth-child(2n+1) {
  background-color: #99a9bf;
}
.roboto{
  font-family: 'Roboto Serif', serif;
  font-weight: 500;
  font-size: 30px;
  line-height: 35px;
}
</style>
